import TopTitle from './TopTitle';
export { TopProps } from './TopTitle';

export default TopTitle;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/top-title/index.tsx